<template>
    <div class="p-4 mb-4 bg-white shadow-md md:flex rounded-3xl shadow-black/5 ring-1 ring-black/5 ">
        <a v-if="module.imageUrl" :href="`/${module.id}/${module.slug}`" :alt="module.topic" :title="module.topic"
            class="shrink-0 guide-img-container">
            <img :src="module.imageUrl" :alt="module.topic" :title="module.topic"
                class="object-cover w-20 h-20 p-4 md:w-48 md:h-full rounded-3xl sm:p-0">
        </a>
        <div class="justify-between ml-4 md:flex-1 md:flex md:flex-col">
            <div class="items-center flex-none mb-2">
                <a :href="`/${module.id}/${module.slug}`" :alt="module.topic" :title="module.topic"
                    class=" hover:underline">
                    <h3 class="text-xl font-semibold">{{ module.topic }}</h3>
                </a>
                <p v-if="module.subtitle2" class="">{{ module.subtitle2}}</p>
                <div class="flex-none min-w-full text-clay-950">{{ module.excerpt }}</div>
            </div>
            <div class="flex justify-between">
                <dl class="mr-4">
                    <dd v-if="module.subtitle1" class="text-clay-800">{{ module.subtitle1
                        }}</dd>


                    <dd class="mb-2 text-sm text-clay-800 line-clamp-2">{{ module.learningModelCategories.join(", ")
                        }}
                    </dd>

                </dl>
                <div>
                    <div class="mt-2 ml-4 shrink-0">
                        <div class="relative inline-flex items-center">
                            <Bookmarking :id="module.id"></Bookmarking>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import {LearningModuleDtoLightWeight} from "@/dtos";

const props = defineProps({
    module: {},
})

const module: LearningModuleDtoLightWeight = props.module;

</script>
<style>

</style>